import AbstractAPI from './AbstractAPI';

export default class TransloaditAPI extends AbstractAPI {
  getSignatureAuth(templateType = 'default') {
    return this.get(`transloadit?template_type=${templateType}`);
  }
}
